export default __webpack_public_path__ + "static/media/para-logo.96078e8e.svg";